import React from "react";
import {Grid, Tab, Tabs} from "@mui/material";
import {isVitrayaInternalUser} from "../../constants/UserAuth";

function TabHeader(props) {
    const {tabValue, handleChange, claimData} = props;
    return (
        <Grid>
            <Tabs value={tabValue} onChange={handleChange} centered>
                {
                    <Tab
                        value="summary"
                        label="Summary"
                        style={{fontWeight: "bold", fontSize: 16}}
                    />
                }
                {/* {claimData?.billIdentifier && claimData?.billFound &&  */}
                <Tab
                    value="bill"
                    label="Bills"
                    style={{fontWeight: "bold", fontSize: 16}}
                    disabled={claimData?.billIdentifier && claimData?.billFound ? false : true}
                />
                {/* } */}
                {/* {claimData?.tariffIdentifier && claimData?.billFound &&  */}
                <Tab
                    value="tariff"
                    label="Tariff"
                    style={{fontWeight: "bold", fontSize: 16}}
                    disabled={claimData?.tariffIdentifier && claimData?.billFound ? false : true}
                />
                {/* } */}
                {/* {claimData?.medicalIdentifier &&  */}
                <Tab
                    value="vNeuron"
                    label="Medical Admissibility"
                    style={{fontWeight: "bold", fontSize: 16}}
                    // disabled={claimData?.medicalIdentifier ? false : true}
                />
                {/* } */}
                {/* {claimData?.pmlIdentifier &&  */}
                <Tab
                    value="pml"
                    label="Policy Rules"
                    style={{fontWeight: "bold", fontSize: 16}}
                    disabled={
                        claimData?.pmlIdentifier
                            ? false
                            : true
                    }
                />
                {/* } */}
                {isVitrayaInternalUser() && (
                    <Tab
                        value="documents"
                        label="Transaction Documents"
                        style={{fontWeight: "bold", fontSize: 16}}
                    />
                )}
                {isVitrayaInternalUser() && (
                    <Tab
                        value="claim_documents"
                        label="Claim Documents"
                        style={{fontWeight: "bold", fontSize: 16}}
                    />
                )}

                 {
                    <Tab
                        value="stp_details"
                        label="STP Details"
                        style={{fontWeight: "bold", fontSize: 16}}
                    />
                }

                 {
                    <Tab
                        value="auth_letter"
                        label="Authorization Letter"
                        style={{fontWeight: "bold", fontSize: 16}}
                    />
                }
            </Tabs>
        </Grid>
    );
}

export default TabHeader;
